/**
 * Orchestra AI Platform - Method Badge Component
 * 
 * Badge component for displaying HTTP method
 * 
 * @fileoverview HTTP method badge with color coding
 */

import PropTypes from 'prop-types';
import './MethodBadge.css';

/**
 * Method Badge Component
 * @param {Object} props
 * @param {('GET'|'POST'|'PUT'|'DELETE')} props.method - HTTP method
 * @param {('sm'|'md'|'lg')} [props.size='md'] - Badge size
 */
export function MethodBadge({ method, size = 'md' }) {
  const methodClass = method.toLowerCase();
  
  return (
    <span
      className={`method-badge method-badge-${size} method-badge-${methodClass}`}
    >
      {method}
    </span>
  );
}

MethodBadge.propTypes = {
  method: PropTypes.oneOf(['GET', 'POST', 'PUT', 'DELETE']).isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

